module.exports = __webpack_public_path__ + "img/contract_bg4.401cc094.png";